
import { VuexModule, Module, Mutation, Action } from 'vuex-module-decorators';
import Bill from '@/extend/classes/Bill';
import { storeSession } from '@/generated/stores';
import HubServices from "@/generated/hub/HubServices";
import ListData, { ListItem, ColumnConfig, ListConfig, ListFilter } from '@/extend/classes/ListData';
import { Alerts } from '@/framework/base/helpers/Alerts';

import { v4 as uuidv4 } from 'uuid';


@Module({ name: 'storeBill' })

export default class storeBill extends VuexModule {
  // States
  private reccords: Bill[] = [];
  private config : ColumnConfig[] = [];
  private idsLoading: number[] = [];
  private dataLoading = false;
  private dataLoaded = false;
  private dataRegistered = false;

  // Getters on states for asynchronous actions
  private get billLoading (): boolean {
    return this.dataLoading;
  }
  private get billRegistered (): boolean {
    return this.dataRegistered;
  }

  
  public get billLoaded (): boolean {
    return this.dataLoaded;
  }

  public get createNewBill() {
    return (): Bill => { 
      return this.getBill(0, true);
    }
  }

  
  public get getBill () {
    return (id: number, canCreate = false): Bill => {
      if (id == 0 && !canCreate) {
        Alerts.debug("Id Bill can't be 0")
        return new Bill();
      }
      const res = this.reccords.find(c => c.id == id);
      if (res != undefined) {
        return res;
      } else {
        const copy = new Bill();
        if (id == 0) {
          if (this.reccords.length == 0) {
            copy.id = -1;
          } else {
            this.reccords.sort((a, b) => (a.id - b.id));
            copy.id = Math.min(-1, this.reccords[0].id - 1);
          }          copy.canDelete = true;          copy.canUpdate = true;
          copy.createId = uuidv4();
          this.reccords.push(copy);
        } else if (id > 0) {
          copy.id = id;
          this.reccords.push(copy);
          if (storeSession.httpCx != undefined && !this.idsLoading.includes(id)) {
            this.idsLoading.push(id);
            Bill.getForStore(id).then((data: ListData) => {
              const tmpCopy = this.reccords.find(a => a.id == id);
              if (tmpCopy) {
                tmpCopy.fromBill(data.reccords[0] as Bill);
              }
              const config = data.config as ListConfig
              if (this.config.length == 0) {
                config.columnsConfig.forEach((column) => {
                  this.config.push(column);
                })
              } else {
                config.columnsConfig.forEach((column) => {
                  if (column.choix.length == 1) {
                    const columnConfig = this.config.find(a => a.name == column.name);
                    if (columnConfig && !columnConfig.choix.find(a => a.value == column.choix[0].value)) {
                      const columnChoix = columnConfig.choix;
                      const newChoix = column.choix[0];
                      columnChoix.push(newChoix);
                    }
                  }
                });
              }
              const index = this.idsLoading.findIndex(x => x == id);
              if (index >= 0) {
                this.idsLoading.splice(index, 1);
              }
            })
          }
        }
        return copy
      }
    }
  }


  

  public get listBill (): Bill[] {
    return this.reccords;
  }

  public get listConfigBill (): ColumnConfig[] {
    return this.config;
  }


  @Mutation
  private mBillRegistered (): void {
    this.dataRegistered = true;
  }

  @Mutation
  public mBillClearData (): void {
    this.reccords = [];
    this.idsLoading = [];
    this.dataLoading = false;
    this.dataLoaded = false;
    this.dataRegistered = false;
  }

  @Mutation
  private mBillLoading (value: boolean): void {
    this.dataLoading = value;
  }

  @Mutation
  private mBillLoaded (data: ListData): void {
    this.dataLoaded = true;
    this.idsLoading.splice(0, this.idsLoading.length);
    this.reccords = [];
    data.reccords.forEach((reccord) => {
      this.reccords.push(Bill.fromJson(reccord as Bill));
    })
    Bill.getDate(this.reccords);
    this.config = data.config.columnsConfig;
  }

  @Mutation
  private mBillConfigUpdated (newConfig: ListConfig): void {
    newConfig.columnsConfig.forEach((column) => {
      if (column.choix.length == 1) {
        const columnConfig = this.config.find(a => a.name == column.name);
        if (columnConfig && !columnConfig.choix.find(a => a.value == column.choix[0].value)) {
          const columnChoix = columnConfig.choix;
          const newChoix = column.choix[0];
          columnChoix.push(newChoix);
          console.log(newChoix);
        }
      }
    });
  }

  @Mutation
  public mBillCreated (obj: Bill): void {
    const index = this.idsLoading.findIndex(x => x == obj.id);
    if (index < 0) {
      let api = this.reccords.find(x => x.id == obj.id);
      if (api) {
        if (!api.compareBill(obj)) {
          api.fromBill(obj);
        }
      } else {
        api = this.reccords.find(x => x.createId == obj.createId && obj.createId != null && obj.createId != '');
        if (api) {
          if (!api.compareBill(obj)) {
            api.fromBill(obj);
          } else if (api.id != obj.id ) {
            api.id = obj.id;
          }
        } else {
          this.reccords.push(obj);
        }
      }
    }
  }

  @Mutation
  public mBillUpdated (obj: Bill): void {
    const index = this.idsLoading.findIndex(x => x == obj.id);
    if (index < 0) {
      const api = this.reccords.find(x => x.id == obj.id);
      if (api) {
        if (!api.compareBill(obj)) {
          api.fromBill(obj);
        }
      } else {
        this.reccords.push(obj);
      }
    }
  }

  @Mutation
  public mBillDeleted (id: number): void {
    const index = this.reccords.findIndex(x => x.id == id);
    if (index >= 0) {
      this.reccords.splice(index, 1);
    }
  }

    
  @Action
  public registerBill (filter: ListFilter | null = null): Promise<boolean> {
    return new Promise((resolve) => {
      if (!this.billRegistered && storeSession.hubUsed) {
        if (HubServices.hubReady()) {
          HubServices.registerBill(this.billCreated, this.billUpdated, this.billDeleted);
          this.mBillRegistered();
        } else {
          setTimeout(() => resolve(this.registerBill(filter)), 1000);
        }
      }
      if (filter != null) {
        if (HubServices.hubReady() && !this.billLoading && !this.billLoaded) {
          this.mBillLoading(true);
          return Bill.list(filter)
            .then((data: ListData) => {
              this.mBillLoaded(data);
              this.mBillLoading(false);
              resolve(true);
            })
        }
      } else  {
        resolve(true);
      }
  })
}


  @Action
  public listFilteredBill (filter: ListFilter): Promise<boolean> {
    return new Promise((resolve) => {
      if (HubServices.hubReady() && !this.billLoading) {
        this.mBillLoading(true);
        return Bill.list(filter)
          .then((data: ListData) => {
            this.mBillLoaded(data);
            this.mBillLoading(false);
            resolve(true);
          })
      }
    })
  }


  
  @Action
  private billCreated (objConfig: ListItem): void {
    const config = objConfig.config as ListConfig
    this.mBillConfigUpdated(config)
    const obj = objConfig.obj as Bill;
    this.mBillCreated(Bill.fromJson(obj));
  }

  @Action
  private billUpdated (objConfig: ListItem): void {
    const config = objConfig.config as ListConfig
    this.mBillConfigUpdated(config)
    const obj = objConfig.obj as Bill;
    this.mBillUpdated(Bill.fromJson(obj));
  }

  @Action
  private billDeleted (objConfig: ListItem): void {
    const obj = objConfig.obj as Bill;
    this.mBillDeleted(obj.id);
  }
}
